<template>
  <div>
    <div class="category-top-bar" ref="optionsTopBar">
      <div class="top-bar">
        <p>
          <a class="btn btn-orange btn-icon back" @click="goBack">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
        </p>
        <p class="d-inline-flex">
            <button type="submit" class="btn btn-icon btn-success mar-rt-10 save" style="margin-bottom: 0;" @click.prevent="generateNir(invoice._id)" :title="$t('gestiune.generateNir')">
              {{$t('gestiune.generateNir')}}
            </button>
        </p>
      </div>
    </div>
    <div class="card bon-details" v-if="invoice">
      <!-- Customer -->
      <div class="box">
        <h5>{{ $t('gestiune.customer') }}</h5>
        <p><strong>{{ $t('gestiune.name') }}:</strong> {{ invoice.customer.name }}</p>
        <p><strong>{{ $t('gestiune.vat') }}:</strong> {{ invoice.customer.vat }}</p>
        <p><strong>{{ $t('gestiune.identificationCode') }}:</strong> {{ invoice.customer.identificationCode }}</p>
        <p><strong>{{ $t('gestiune.address') }}:</strong> {{ formatAddress(invoice.customer.address) }}</p>
      </div>

      <!-- Supplier + Invoice Info -->
      <div class="box">
        <h5>{{ $t('gestiune.supplier') }} & {{ $t('gestiune.invoice') }}</h5>
        <p><strong>{{ $t('gestiune.name') }}:</strong> {{ invoice.supplier.name }}</p>
        <p><strong>{{ $t('gestiune.vat') }}:</strong> {{ invoice.supplier.vat }}</p>
        <p><strong>{{ $t('gestiune.invoiceNumber') }}:</strong> {{ invoice.invoiceNumber }}</p>
        <p><strong>{{ $t('invoice.issueDate') }}:</strong> {{ formatDate(invoice.issueDate) }}</p>
        <p><strong>{{ $t('gestiune.dueDate') }}:</strong> {{ formatDate(invoice.dueDate) }}</p>
      </div>
    </div>
    <div class="card mar-to-15 tableInvoice">
      <div class="card-content">
        <div :class="(loading ? 'show-loader' : 'hide-loader')">
          <div class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
            </svg><!---->
          </div>
        </div>
        <div class="data-table">
          <el-table :data="tableData" :empty-text="$t('gestiune.noData')" style="width: 100%;">

            <el-table-column prop="id" label="ID" width="60"></el-table-column>

            <el-table-column prop="name" :label="$t('gestiune.stockNameTable')" width="200">
              <template slot-scope="scope">
                {{ scope.row && scope.row.name ? scope.row.name : '' }}
              </template>
            </el-table-column>

            <el-table-column :label="$t('gestiune.cantitate')" width="120">
              <template slot-scope="scope">
                <span v-if="scope.row && scope.row.quantity">
                  {{ scope.row.quantity.value }}
                </span>
                <span v-else>-</span>
              </template>
            </el-table-column>

            <el-table-column :label="$t('gestiune.unit')" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row && scope.row.quantity && scope.row.quantity.unit">
                  {{ getUnitText(scope.row.quantity.unit) }}
                </span>
                <span v-else>-</span>
              </template>
            </el-table-column>

            <el-table-column :label="$t('gestiune.price')">
              <template slot-scope="scope">
                <span v-if="scope.row && scope.row.price">
                  {{ scope.row.price.value }}
                  {{ scope.row.price.currency }}
                </span>
                <span v-else>-</span>
              </template>
            </el-table-column>

            <el-table-column :label="$t('gestiune.lineTotal')">
              <template slot-scope="scope">
                <span v-if="scope.row && scope.row.lineExtensionAmount">
                  {{ scope.row.lineExtensionAmount.value }}
                  {{ scope.row.lineExtensionAmount.currency }}
                </span>
                <span v-else>-</span>
              </template>
            </el-table-column>

            <el-table-column :label="$t('gestiune.taxRate')">
              <template slot-scope="scope">
                {{ scope.row && scope.row.taxRate !== undefined ? scope.row.taxRate : '-' }}
              </template>
            </el-table-column>

          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      loadingTimeout: null,
      tableData: [],
      invoice: null
    }
  },
  props: {
    route: {
      type: Object,
      default: () => ({})
    }
  },
  created () {
    this.companyID = this.$session.get('selectedCompany')
  },
  mounted () {
    const id = this.route && this.route.params && this.route.params.id
    if (id) {
      this.fetchInvoiceSupplier(id)
    }
  },
  methods: {
    goBack () {
      this.$bus.$emit('close-modal')
    },
    formatDate (value) {
      if (!value) return ''
      const date = new Date(value)
      return isNaN(date.getTime()) ? '' : date.toLocaleDateString()
    },
    formatAddress (address) {
      if (!address) return ''
      return `${address.street}, ${address.city}, ${address.county}, ${address.country}`
    },
    generateNir (id) {
      this.$router.push({
        path: `/management/entries/add`,
        query: {
          id: id,
          vatNumber: this.invoice && this.invoice.customer ? this.invoice.customer.vat : '',
          isInvoiceSupplier: true
        }
      })
    },
    async fetchInvoiceSupplier (id) {
      this.$bus.$emit('set-loading', true)
      try {
        const response = await fetch(
          `${process.env.API_BASE_URL_GESTIUNE}:4443/purchase/${id}?externalCompanyId=${this.companyID}`,
          { method: 'GET' }
        )

        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        const result = await response.json()

        this.invoice = result
        this.tableData = result.items || []

        console.log('✅ Bon fiscal details fetched successfully:', this.tableData)
      } catch (error) {
        console.error('❌ Eroare la fetch bon fiscal by ID:', error)
        this.invoice = null
        this.tableData = []
      } finally {
        this.$bus.$emit('set-loading', false)
      }
    }
  }
}
</script>

<style scoped>
.tableInvoice .el-table .cell {
  height: 90px;
}
.bon-details {
  font-size: 14px;
  margin-top: 10px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 6px 16px;
  padding: 10px 14px;
  border-radius: 6px;
}
.bon-details .box {
  background: #fff;
  padding: 10px;
  border-radius: 6px;
}
.global-loader {
  position: fixed;
  inset: 0;
  z-index: 50000; /* sub modal, dar peste restul */
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: 'Arial', sans-serif;
  color: #fff;
  pointer-events: all;
}
.card p {
  font-size: 14px;
}
h5, .h5 {
  font-size: 18px;
  font-weight: 500;
}
.global-loader p {
  margin-top: 16px;
  font-size: 1.2em;
  letter-spacing: 0.5px;
  animation: pulse 1.5s infinite;
}

/* Spinner animat */
.spinner {
  width: 64px;
  height: 64px;
  border: 8px solid rgba(255, 255, 255, 0.3);
  border-top: 8px solid #fff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

strong {
  color: #25396F;
}

/* Animatie spinner */
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Animatie text */
@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.6; }
}
.action-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.left-buttons {
  display: flex;
}

.left-buttons button {
  display: flex;
  align-items: center;
  padding-top: 10px;
}

.right-button {
  margin-left: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/Entries/ManagementInvoiceSupplierView.vue